import { useQuery } from '@tanstack/react-query';

import { useAuthHydration } from '@/hooks/use-auth-hydration';
import { useMembership } from '@/hooks/use-membership';
import api from '@/services/api';
import { TeamPayments, TeamPaymentsFilter } from '@/types/charge';
import { chargeKeys } from './use-charges';

export interface UseTeamPaymentsOptions {
  status?: TeamPaymentsFilter;
  providerId?: string;
  page?: number;
  limit?: number;
}

/**
 * Cobranças da organização inteira para dar baixa no caixa único. Não segue o
 * foco. A chave fica sob `chargeKeys.all`: confirmar um pagamento já refaz a lista.
 */
export function useTeamPayments(options?: UseTeamPaymentsOptions) {
  const isHydrated = useAuthHydration();
  const { can } = useMembership();

  return useQuery({
    queryKey: [...chargeKeys.all, 'team', options],
    queryFn: async () =>
      (
        await api.get<TeamPayments>('/dashboard/team-payments', {
          params: {
            status: options?.status,
            providerId: options?.providerId,
            page: options?.page ?? 1,
            limit: options?.limit ?? 20,
          },
        })
      ).data,
    enabled: isHydrated && can('teamPayments'),
  });
}
